import staticQueryData from "../../public/static/d/762386259.json";
import { flatten } from 'helpers';
export const useTertiaryNavigationData = () => {
  var _queryData$prismicNav, _queryData$prismicNav2;

  const queryData = staticQueryData.data;
  const navItems = (queryData === null || queryData === void 0 ? void 0 : (_queryData$prismicNav = queryData.prismicNavigation) === null || _queryData$prismicNav === void 0 ? void 0 : (_queryData$prismicNav2 = _queryData$prismicNav.data) === null || _queryData$prismicNav2 === void 0 ? void 0 : _queryData$prismicNav2.primary) || [];
  return flatten(navItems.map(navItem => navItem.primary));
};